/**
 * The sheet shows SRD words (class, race, weapon, feature, property, damage type, school…) in the interface language:
 * the data keeps the SRD name (the rules match on it), the screen reads `L(name)`. Charsheet pass №58.
 */
import { useCallback } from 'react';
import { useI18n } from '../../i18n';
import { srdLabel, srdLanguageLabel, srdPropertiesLabel, srdSpellText } from '@roll1/shared/systems/dnd5e/srd/ru-labels.js';

export function useSrdLabel() {
  const { locale } = useI18n();
  const L = useCallback((name: string | undefined | null): string => (name ? srdLabel(name, locale) : ''), [locale]);
  const Lang = useCallback((name: string): string => srdLanguageLabel(name, locale), [locale]);
  const Props = useCallback((props: string | undefined): string => (props ? srdPropertiesLabel(props, locale) : ''), [locale]);
  const Sp = useCallback((text: string | undefined): string => (text ? srdSpellText(text, locale) : ''), [locale]);
  return { L, Lang, Props, Sp, locale };
}
